import React, { Fragment } from "react";

import "./Login.css";
import { PROJECT_SSO_LOGIN_SUCCESS, SSO_LOGIN_SUCCESS } from "App/Routes";
import LoginImageRow from "./LoginImageRow";
import LoginDivider from "components/Login/LoginDivider";
import LoginPage from "components/Login/LoginPage";

import {
  ENABLE_REGISTER_PAGES,
  PRIVACY_PAGE_LINK,
  ENABLE_LOGIN_HOME,
  ENABLE_LOGIN_TOPBAR,
  ENABLE_OAUTH_LOGIN,
  SSO_LOGIN_LINK,
  PLAYER_URL,
  BASE_URL,
  ENABLE_EMAIL_LOGIN
} from "config";
import urlServices from "services/urlServices";
import localize from "lang/localize";

class PgConnectLoginPage extends LoginPage {
  /*
    Custom: Render a section with app links with direct download for Android APKs;
    Folks in China cannot access the Play Store.
  */
  renderAppLinks() {
    return (
      <Fragment>
        <p className="topmargin-40 text-align-center bottommargin-10">
          <strong>Download the P&G Connect App:</strong>
        </p>
        <p className="text-align-center nomargin">
          <a
            className="default"
            href="https://apps.apple.com/us/app/p-g-connect/id1260910508"
            target="_blank"
            rel="noopener noreferrer"
          >
            iOS
          </a>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a
            className="default"
            href="https://play.google.com/store/apps/details?id=com.gametize.rdcore&hl=en_SG"
            target="_blank"
            rel="noopener noreferrer"
          >
            Android
          </a>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a
            className="default"
            href="https://gametize-share.s3.amazonaws.com/pgconnect/png_connect.apk"
          >
            Direct Download
          </a>
        </p>
      </Fragment>
    );
  }

  /* Custom: Layout of SSO Login Section */
  renderSSOLoginSection() {
    const OAUTH_LINK_FULL =
      SSO_LOGIN_LINK +
      PLAYER_URL +
      urlServices.removeFirstSlash(
        this.props.projectId
          ? PROJECT_SSO_LOGIN_SUCCESS.format(this.props.projectId)
          : SSO_LOGIN_SUCCESS
      );

    if (ENABLE_OAUTH_LOGIN && !ENABLE_LOGIN_HOME) {
      return (
        <div className="pure-g box-sizing-border-box-all">
          <div className="fullwidth">
            <div className="pure-u-1-6 pure-u-lg-1-4" />
            <div className="pure-u-2-3 pure-u-lg-1-2 bottommargin-20 text-align-center">
              <a className="button fullwidth cta" href={OAUTH_LINK_FULL}>
                {localize("button_login_sso", this.props.language)}
              </a>
              <a
                className="default"
                href={BASE_URL + "appterms"}
                target="_blank"
                rel="noopener noreferrer"
              >
                Employee Privacy Policy
              </a>
            </div>
            <div className="pure-u-1-6 pure-u-lg-1-4" />
          </div>
          <div
            className={
              "pure-u-1-1" + (ENABLE_EMAIL_LOGIN ? " bottommargin-30" : "")
            }
          >
            <LoginDivider />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    if (
      /* checking type is important: showPrivacyAgreement is initialised as null */
      typeof this.props.showPrivacyAgreement === "boolean" &&
      this.props.showPrivacyAgreement === true
    ) {
      return (
        <div className="login-register-container container verticalpadding">
          {this.renderTopbarlessBackButton()}
          <LoginImageRow />
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
              <h5>
                {localize(
                  "login_view_privacy_policy_updated_title",
                  this.props.language
                )}
              </h5>
              <p>
                {localize("login_agree_to_new_terms_text", this.props.language)}
              </p>
              <div className="bottommargin-30">
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdatePrivacyAgreed}
                    checked={this.props.privacyAgreed}
                  />{" "}
                  {localize(
                    "register_agree_to_gametize_text",
                    this.props.language
                  )}
                  <a
                    className="link default"
                    href={PRIVACY_PAGE_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {localize(
                      "register_privacy_policy_text",
                      this.props.language
                    )}
                  </a>
                  .
                </p>
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdateMarketingConsent}
                    checked={this.props.marketingConsent}
                  />{" "}
                  {localize(
                    "register_marketing_communications_text",
                    this.props.language
                  )}
                </p>
              </div>
              <div className="pure-g bottommargin">
                <div className="pure-u-11-24 pure-u-sm-14-24 pure-u-lg-2-3" />
                <div className="pure-u-13-24 pure-u-sm-10-24 pure-u-lg-1-3">
                  <button
                    className={
                      "button fullwidth " +
                      (this.props.privacyAgreed ? "cta" : "inactive")
                    }
                    onClick={this.props.handlePrivacySubmit}
                    disabled={!this.props.privacyAgreed}
                  >
                    {localize("button_quest_continue", this.props.language)}
                  </button>
                </div>
              </div>
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    } else {
      return (
        <div className="login-register-container container verticalpadding">
          {this.renderTopbarlessBackButton()}
          <LoginImageRow />
          <div
            className={
              "innerblock pure-g" + (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR)
                ? " topmargin-20"
                : ""
            }
          >
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
              {/* Custom: Added renderSSOLoginSection() here */}
              {this.renderSSOLoginSection()}
              <form
                className="pure-form"
                onSubmit={this.handlePreSubmit.bind(this)}
              >
                {this.renderLoginFields()}
                {this.renderGuestLoginSection()}
                {/* Custom: Removed renderSSOLoginSection() here */}
                {ENABLE_REGISTER_PAGES && this.renderRegisterSection()}
                {/* Custom: List of app links */}
                {this.renderAppLinks()}
              </form>
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    }
  }
}

export default PgConnectLoginPage;
